import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

/**
 * Function that toggles the header menu.
 */
export default function toggleMobileMenu() {
  const header = document.querySelector( '.js-header' )

  if ( !header ) {
    return
  }

  let currentHamburger

  const menu = header.querySelector( '.js-mobile-menu-container' )
  const hamburgers = header.querySelectorAll( '.js-hamburger' )
  const closeButtons = header.querySelectorAll( '.js-mobile-menu-close' )

  Array
    .from( hamburgers ).forEach( hamburger =>
      hamburger.addEventListener( 'click', openMenu ) )

  Array
    .from( closeButtons ).forEach( closeButton =>
      closeButton.addEventListener( 'click', closeMenu ) )

  /**
   * Opens the mobile menu.
   */
  function openMenu() {
    currentHamburger = this
    currentHamburger.setAttribute( 'aria-expanded', 'true' )
    menu.classList.remove( 'invisible' )
    menu.classList.remove( 'left-100%' )
    menu.classList.add( 'left-0' )
    disableBodyScroll( menu )
  }

  /**
   * Closes the mobile menu.
   */
  function closeMenu() {
    currentHamburger.setAttribute( 'aria-expanded', 'false' )
    menu.classList.add( 'invisible' )
    menu.classList.add( 'left-100%' )
    menu.classList.remove( 'left-0' )
    enableBodyScroll( menu )
  }
}
